import { render, staticRenderFns } from "./candidate-details.vue?vue&type=template&id=5a541729&scoped=true&"
import script from "./candidate-details.vue?vue&type=script&lang=js&"
export * from "./candidate-details.vue?vue&type=script&lang=js&"
import style0 from "./candidate-details.vue?vue&type=style&index=0&id=5a541729&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a541729",
  null
  
)

export default component.exports